import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgStore = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M8 0C3.58204 0 0 3.58139 0 8C0 12.4186 3.58204 16 8 16C12.418 16 16 12.4186 16 8C16 3.58139 12.4186 0 8 0ZM12.1946 8.71902C12.1946 8.88882 12.0562 9.02727 11.8864 9.02727H9.02727V11.8864C9.02727 12.0562 8.88882 12.1946 8.71902 12.1946H7.28098C7.11118 12.1946 6.97273 12.0562 6.97273 11.8864V9.02727H4.11363C3.94384 9.02727 3.80539 8.88882 3.80539 8.71902V7.28098C3.80539 7.11118 3.94384 6.97273 4.11363 6.97273H6.97273V4.11363C6.97273 3.94384 7.11118 3.80539 7.28098 3.80539H8.71902C8.88882 3.80539 9.02727 3.94384 9.02727 4.11363V6.97273H11.8864C12.0562 6.97273 12.1946 7.11118 12.1946 7.28098V8.71902ZM7.43249 1.88343C6.47576 1.88343 5.56539 2.08327 4.74057 2.4418C5.69665 1.88016 6.81078 1.55755 8 1.55755C11.5579 1.55755 14.4424 4.44212 14.4424 8C14.4424 8.94041 14.2407 9.8338 13.8782 10.6397C14.0754 10.0056 14.1812 9.33159 14.1812 8.63282C14.1812 4.90514 11.1602 1.88343 7.43249 1.88343Z" />
  </svg>
)
const ForwardRef = forwardRef(SvgStore)
const IconSvgStore = createIcon(ForwardRef, 'SvgStore')
export default IconSvgStore
